(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["curvevia-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cv-faq]').forEach((root) => {
    if (root.dataset.faqReady === 'true') return;
    root.dataset.faqReady = 'true';
    const input = root.querySelector('[data-cv-faq-search]');
    const groups = [...root.querySelectorAll('[data-cv-faq-group]')];
    const empty = root.querySelector('[data-cv-faq-empty]');
    if (!input) return;

    input.addEventListener('input', () => {
      const query = input.value.trim().toLowerCase();
      let visibleCount = 0;
      groups.forEach((group) => {
        let groupCount = 0;
        group.querySelectorAll('[data-cv-faq-item]').forEach((item) => {
          const isMatch = !query || item.textContent.toLowerCase().includes(query);
          item.hidden = !isMatch;
          if (isMatch) groupCount += 1;
        });
        group.hidden = groupCount === 0;
        visibleCount += groupCount;
      });
      empty.hidden = visibleCount !== 0;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
